import React from 'react';
import { Button, Container, ProgressCircle, Typography } from '@sm/wds-react';

export const BUTTON_TEST_ID = 'UnlinkedButtonOptionButton';
export const SPINNER_TEST_ID = 'UnlinkedButtonOptionSpinner';
export const TEST_ID = 'UnlinkedButtonOption';

export default function UnlinkedButtonOption({
  isDisabled,
  showSpinner,
  titleText,
  buttonText,
  onClick,
  id,
  href,
}: {
  isDisabled: boolean;
  showSpinner: boolean;
  titleText: string;
  buttonText: string;
  id?: string;
  href?: string;
  onClick(): void;
}): JSX.Element {
  let containerTestId: string = TEST_ID;
  let buttonTestId: string = BUTTON_TEST_ID;
  let spinnerTestId: string = SPINNER_TEST_ID;
  if (typeof id !== 'undefined') {
    const suffix = `__${id}`;
    containerTestId = `${containerTestId}${suffix}`;
    buttonTestId = `${buttonTestId}${suffix}`;
    spinnerTestId = `${spinnerTestId}${suffix}`;
  }

  return (
    <Container data-testid={containerTestId} flex flexAlign="center" flexJustify="center">
      <Container className="sm-unlinked-page__sign-up-spinner" hidden={!showSpinner}>
        <ProgressCircle continuous data-testid={spinnerTestId} />
      </Container>
      <Button
        className="sm-unlinked-page sm-unlinked-page__button-choice wds-p-5 wds-flex wds-flex--y wds-flex--start"
        color="alt"
        data-testid={buttonTestId}
        disabled={isDisabled}
        onClick={onClick}
        href={href}
      >
        <Typography variant="cardTitle">{titleText}</Typography>
        <Typography className="wds-m-t-4">{buttonText}</Typography>
      </Button>
    </Container>
  );
}

UnlinkedButtonOption.defaultProps = {
  id: undefined,
  href: undefined,
};
